import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { runtimeConfig } from '../config/runtimeConfig';

let client: SupabaseClient | null = null;

export function supabase(): SupabaseClient {
  if (!client) {
    const { supabaseUrl, supabaseAnonKey } = runtimeConfig();
    client = createClient(supabaseUrl, supabaseAnonKey);
  }
  return client;
}
